module.exports = __webpack_public_path__ + "img/top-brand.f1810cfd.webp";